import {
  LayoutDashboard, FolderKanban, Factory, Wrench, AlertOctagon, Droplets,
  Package, ShieldCheck, FileBarChart, Users, Building2, HardHat,
  FlaskConical, FileArchive, History, Zap, Truck, Settings as SettingsIcon,
  ClipboardList, PackageCheck, AlertTriangle, CalendarClock, Clock,
  BarChart3, LineChart, Database, Network, Receipt, ShieldAlert,
} from "lucide-react";

const OPS = ["super_admin", "company_admin", "site_manager", "shift_supervisor"];
const ADMIN = ["super_admin", "company_admin"];

// Enterprise Information Architecture. Existing pages keep their exact routes.
// `soon` items are future modules — disabled, no route. `shortcut` jumps to an existing page.
export const NAV = [
  { type: "link", to: "/", label: "Dashboard", icon: LayoutDashboard, roles: "*", testid: "sidebar-nav-dashboard" },
  { type: "link", to: "/projects", label: "Projects", icon: FolderKanban, roles: ["super_admin", "company_admin", "site_manager"], testid: "sidebar-nav-projects" },

  { type: "group", label: "Operations", icon: Factory, testid: "sidebar-group-operations", children: [
    { type: "link", to: "/production", label: "Production", icon: Factory, roles: OPS, testid: "sidebar-nav-production" },
    { type: "link", to: "/energy", label: "Energy Performance", icon: Zap, roles: OPS, testid: "sidebar-nav-energy" },
    { type: "link", to: "/quality", label: "Quality Control", icon: FlaskConical, roles: ["super_admin", "company_admin", "site_manager", "shift_supervisor", "maintenance_engineer"], testid: "sidebar-nav-quality" },
    { type: "soon", label: "Dispatch", icon: Truck, roles: OPS, testid: "sidebar-nav-dispatch" },
  ] },

  { type: "group", label: "Assets", icon: HardHat, testid: "sidebar-group-assets", children: [
    { type: "link", to: "/equipment", label: "Equipment", icon: HardHat, roles: ["super_admin", "company_admin", "site_manager", "maintenance_engineer", "shift_supervisor"], testid: "sidebar-nav-equipment" },
    { type: "link", to: "/workorders", label: "Job Orders", icon: Wrench, roles: ["super_admin", "company_admin", "site_manager", "maintenance_engineer"], testid: "sidebar-nav-workorders" },
    { type: "link", to: "/breakdowns", label: "Maintenance", icon: AlertOctagon, roles: ["super_admin", "company_admin", "site_manager", "maintenance_engineer", "shift_supervisor"], testid: "sidebar-nav-breakdowns" },
    { type: "link", to: "/lubrication", label: "Lubrication", icon: Droplets, roles: ["super_admin", "company_admin", "site_manager", "maintenance_engineer"], testid: "sidebar-nav-lubrication" },
    { type: "soon", label: "Breakdown History", icon: History, roles: ["super_admin", "company_admin", "site_manager", "maintenance_engineer"], testid: "sidebar-nav-breakdown-history" },
  ] },

  { type: "group", label: "Supply Chain", icon: Package, testid: "sidebar-group-supply-chain", children: [
    { type: "link", to: "/inventory", label: "Inventory", icon: Package, roles: ["super_admin", "company_admin", "site_manager", "store_incharge", "maintenance_engineer"], testid: "sidebar-nav-inventory" },
    { type: "link", to: "/vendors", label: "Vendors", icon: Truck, roles: ["super_admin", "company_admin", "site_manager", "store_incharge"], testid: "sidebar-nav-vendors" },
    { type: "soon", label: "Purchase Requests", icon: ClipboardList, roles: ["super_admin", "company_admin", "site_manager", "store_incharge", "maintenance_engineer"], testid: "sidebar-nav-purchase-requests" },
    { type: "soon", label: "Goods Receipt", icon: PackageCheck, roles: ["super_admin", "company_admin", "site_manager", "store_incharge"], testid: "sidebar-nav-goods-receipt" },
  ] },

  { type: "group", label: "Safety & Compliance", icon: ShieldCheck, testid: "sidebar-group-safety", children: [
    { type: "link", to: "/safety", label: "Safety / HSE", icon: ShieldCheck, roles: ["super_admin", "company_admin", "site_manager", "safety_officer", "shift_supervisor"], testid: "sidebar-nav-safety" },
    { type: "link", to: "/permits", label: "Permit to Work", icon: HardHat, roles: ["super_admin", "company_admin", "site_manager", "safety_officer", "maintenance_engineer"], testid: "sidebar-nav-permits" },
    { type: "soon", label: "Incident Register", icon: AlertTriangle, roles: ["super_admin", "company_admin", "site_manager", "safety_officer"], testid: "sidebar-nav-incident-register" },
    { type: "soon", label: "PPE Register", icon: ShieldAlert, roles: ["super_admin", "company_admin", "site_manager", "safety_officer"], testid: "sidebar-nav-ppe-register" },
  ] },

  { type: "group", label: "People", icon: Users, testid: "sidebar-group-people", children: [
    { type: "link", to: "/users", label: "Users", icon: Users, roles: ADMIN, testid: "sidebar-nav-users" },
    { type: "shortcut", to: "/settings?section=user_roles_permissions", label: "Roles & Permissions", icon: ShieldCheck, roles: ADMIN, testid: "sidebar-nav-roles" },
    { type: "soon", label: "Attendance", icon: CalendarClock, roles: ["super_admin", "company_admin", "site_manager"], testid: "sidebar-nav-attendance" },
    { type: "soon", label: "Shift Management", icon: Clock, roles: ["super_admin", "company_admin", "site_manager"], testid: "sidebar-nav-shift-management" },
  ] },

  { type: "group", label: "Analytics", icon: FileBarChart, testid: "sidebar-group-analytics", children: [
    { type: "link", to: "/reports", label: "Reports", icon: FileBarChart, roles: "*", testid: "sidebar-nav-reports" },
    { type: "link", to: "/audit", label: "Audit Trail", icon: History, roles: ["super_admin", "company_admin", "site_manager"], testid: "sidebar-nav-audit" },
    { type: "soon", label: "KPIs", icon: BarChart3, roles: "*", testid: "sidebar-nav-kpis" },
    { type: "soon", label: "Production Analysis", icon: LineChart, roles: "*", testid: "sidebar-nav-production-analysis" },
    { type: "soon", label: "Energy Analysis", icon: Zap, roles: "*", testid: "sidebar-nav-energy-analysis" },
  ] },

  { type: "link", to: "/customer", label: "Customer Portal", icon: Building2, roles: ["customer", "super_admin", "company_admin"], testid: "sidebar-nav-customer" },
  { type: "link", to: "/documents", label: "Documents", icon: FileArchive, roles: "*", testid: "sidebar-nav-documents" },

  { type: "group", label: "Administration", icon: SettingsIcon, testid: "sidebar-group-administration", children: [
    { type: "link", to: "/master", label: "Master Data", icon: Database, roles: ADMIN, testid: "sidebar-nav-master-data" },
    { type: "soon", label: "Departments", icon: Network, roles: ADMIN, testid: "sidebar-nav-departments" },
    { type: "link", to: "/settings", label: "System Settings", icon: SettingsIcon, roles: ADMIN, testid: "sidebar-nav-settings" },
    { type: "soon", label: "Rates", icon: Receipt, roles: ADMIN, testid: "sidebar-nav-rates" },
  ] },
];

const basePath = (to) => (to || "").split("?")[0];
const matchPath = (to, pathname) => {
  const b = basePath(to);
  if (b === "/") return pathname === "/";
  return pathname === b || pathname.startsWith(b + "/");
};

// Returns { group, label } for the current pathname, for breadcrumbs.
export function getRouteMeta(pathname) {
  for (const node of NAV) {
    if (node.type === "group") {
      for (const c of node.children) {
        if (c.type === "link" && matchPath(c.to, pathname)) return { group: node.label, label: c.label };
      }
    } else if (node.type === "link" && matchPath(node.to, pathname)) {
      return { group: null, label: node.label };
    }
  }
  return null;
}
